import React from 'react';
import { CTAButton } from './CTAButton';
import { Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden bg-gradient-to-b from-white to-rose-50 pt-8 pb-16 md:pt-12 md:pb-24" data-id="element-173">
      <div className="container mx-auto px-4 md:px-6" data-id="element-174">
        {/* Logo Area */}
        <div className="flex justify-center mb-8 md:mb-12" data-id="element-175">
          <div className="flex items-center gap-2" data-id="element-176">
            <div className="bg-red-600 text-white font-bold text-xl p-1 rounded" data-id="element-177">
              DF
            </div>
            <span className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-178">
              Dentafix™
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-179">
          {/* Content Side */}
          <div className="flex flex-col space-y-6 md:space-y-8" data-id="element-180">
            <div className="inline-flex items-center gap-2 bg-rose-100 text-red-800 px-4 py-1.5 rounded-full text-sm font-semibold w-fit" data-id="element-181">
              <span className="flex gap-0.5" data-id="element-182">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-amber-500 text-amber-500" data-id="element-183" />)}
              </span>
              <span data-id="element-184">Trusted by 50,000+ Seniors</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 font-serif leading-tight" data-id="element-185">
              "I Was Afraid to Smile Again… Until I Found This"
            </h1>

            <div className="prose prose-lg text-gray-700 space-y-4" data-id="element-186">
              <p className="italic text-xl text-gray-600 border-l-4 border-red-200 pl-4" data-id="element-187">
                "I still remember the embarrassment at my granddaughter's 7th
                birthday. I laughed at a joke, and my dentures slipped. The
                click was loud enough that everyone turned to look. I wanted to
                disappear."
              </p>
              <p data-id="element-188">
                My name is Margaret, I'm 71, and for years I struggled with
                loose dentures. The messy adhesives tasted awful and failed by
                lunchtime. I stopped eating my favorite foods. I stopped smiling
                in photos.
              </p>
              <p className="font-medium text-gray-900" data-id="element-189">
                Then my dentist quietly recommended a new solution. Not a messy
                paste, but a precision gel. It changed my life overnight.
              </p>
            </div>

            <div className="pt-4" data-id="element-190">
              <CTAButton text="Try Dentafix™ Today" size="xl" pulse={true} data-id="element-191" />
              <p className="mt-4 text-sm text-gray-500 font-medium" data-id="element-192">
                Most denture wearers don't know this simple solution exists…
              </p>
            </div>
          </div>

          {/* Image Side */}
          <div className="relative" data-id="element-193">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-194">
              <img src="https://images.unsplash.com/photo-1581579438747-104c53d7fbc4?w=800&q=80" alt="Margaret smiling confidently" className="w-full h-[500px] object-cover" data-id="element-195" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6" data-id="element-196">
                <p className="text-white font-medium text-lg" data-id="element-197">Margaret, 71</p>
                <p className="text-white/90 text-sm" data-id="element-198">
                  "Finally confident enough to smile again."
                </p>
              </div>
            </div>

            {/* Floating Product Badge */}
            <div className="absolute -bottom-6 -right-6 md:bottom-10 md:-left-10 bg-white p-4 rounded-xl shadow-xl max-w-[200px] animate-bounce duration-[3000ms]" data-id="element-199">
              <div className="flex items-center gap-3" data-id="element-200">
                <div className="bg-green-100 p-2 rounded-full" data-id="element-201">
                  <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-202">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-203" />
                  </svg>
                </div>
                <div data-id="element-204">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-205">Secure Hold</p>
                  <p className="text-xs text-gray-500" data-id="element-206">Up to 3 Days</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}